
// SVG Icon: share
export default { id: "terriajs-share" };
export const id = "terriajs-share";
export const name = "share";
